<template>
  <div id="job-global-notation">
    <div class="rating">
      <el-rate
        v-model="rating"
        void-icon="StarFilled"
        @change="globalRate(rating)"
      />
      <span v-show="!rating || rating === 0">Ajouter une note</span>
      <span v-show="rating > 0">Votre note</span>
    </div>
    <div v-if="rating !== 0" class="comment">
      <div v-if="globalComment && !isModifyComment" class="global-comment">
        {{ globalComment }}
        <span>Votre commentaire <b>-</b> <strong @click="modifyComment">Modifier</strong></span>
      </div>
      <div v-if="!globalComment || isModifyComment" class="no-global-comment">
        <el-input
          ref="inputcomment"
          v-model="comment"
          type="textarea"
          autosize
          :placeholder="'Ajouter un commentaire sur ' + $brand.label"
          @keydown.enter.prevent
          @keyup.enter="sendComment(comment)"
        />
        <span>Votre commentaire <b>-</b> <strong
          v-if="comment.length >= minCharComment"
          @click="sendComment(comment)"
        >Publier</strong></span>
      </div>
    </div>
  </div>
</template>

<script>
import jobService from '@/services/jobs/';

export default {
  components: {},
  props: ['job', 'score', 'token', 'fromUserId'],
  data() {
    return {
      globalRating: 0,
      globalComment: '',
      minCharComment: 5,
      comment: '',
      rating: 0,
      gf: null,
      isModifyComment: false,
    };
  },
  watch: {},
  mounted() {
    if (this.score) {
      this.rating = this.score;
      this.globalRate(this.score);
    }

    if (this.job) {
      if (this.job.globalFeedback) {
        this.gf = this.job.globalFeedback;
        this.rating = this.gf.score;
        this.globalComment = this.gf.feedback;
      }
    }
  },
  methods: {
    modifyComment() {
      this.isModifyComment = true;
    },
    globalRate(rate) {
      this.$mixpanel.track('Notation Student Pop');
      this.globalRating = rate;
      this.comment = '';
      this.$nextTick(() => {
        if (this.$refs.inputcomment) {
          this.$refs.inputcomment.$el.children[0].focus();
        }
      });
      jobService.jobFeedback(this.job, rate, null, () => {}, this.token, this.fromUserId);
    },
    sendComment(comment) {
      if (comment.length >= this.minCharComment) {
        this.$mixpanel.track('Comment Student Pop');
        this.isModifyComment = false;
        this.globalComment = comment;
        if (this.globalComment !== '') {
          jobService.jobFeedback(this.job, this.globalRating, this.globalComment, () => {
            this.$notify({
              title: this.$t('toast_message.notation.register_comment_to_sp.success.title'),
              message: this.$t('toast_message.notation.register_comment_to_sp.success.text'),
              type: 'success',
              duration: 4000,
            });
          }, this.token, this.fromUserId);
        }
      }
    },
  },
};
</script>

<style scoped="scoped">
</style>
